import { render } from "./Aziende.vue?vue&type=template&id=55ccdcf9"
import script from "./Aziende.vue?vue&type=script&lang=js"
export * from "./Aziende.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__